import { Model } from '../general'

export enum RoleType {
  SystemAdministrator = 9,
  CompanyAdministrator = 1,
  Operator = 2,
  Facilitator = 7,
  Viewer = 4,
  External = 8,
}
export enum AccessType {
  None = 0,      // 0000
  Read = 1,      // 0001
  Update = 2,    // 0010
  Create = 4,    // 0100
  Delete = 8,    // 1000
}

export function canRead(access: AccessType) {
  return (access & Read) > 0
}

export function canUpdate(access: AccessType) {
  return (access & Update) > 0
}

export function canCreate(access: AccessType) {
  return (access & Create) > 0
}

export function canDelete(access: AccessType) {
  return (access & Delete) > 0
}

const SystemAdministrator = RoleType.SystemAdministrator
const CompanyAdministrator = RoleType.CompanyAdministrator
const Operator = RoleType.Operator
const Facilitator = RoleType.Facilitator
const Viewer = RoleType.Viewer
const External = RoleType.External


const None = AccessType.None
const Read = AccessType.Read
const Update = AccessType.Update
const Create = AccessType.Create
const Delete = AccessType.Delete
const All = Read | Update | Create | Delete

/* eslint-disable prettier/prettier */
export const RolePermissions = {
  insights: (role): AccessType => {
    switch (role) {
      case SystemAdministrator:
      case CompanyAdministrator:
      case Facilitator:
      case Viewer:
        return All
      default:
        return None
    }
  },
  kiosk: (role): AccessType => {
    switch (role) {
      case SystemAdministrator:
      case CompanyAdministrator:
      case Facilitator:
      case Viewer:
        return Read
      default:
        return None
    }
  },
  workspace: (role): AccessType =>  {
    switch (role) {
      case SystemAdministrator:
      case CompanyAdministrator:
      case Facilitator:
        return All
      case Operator:
        return Read | Create
      case External:
        return Read
      default:
        return None
    }
  },
  product: (role): AccessType => {
    switch (role) {
      case SystemAdministrator:
      case CompanyAdministrator:
      case Operator:
        return All
      default:
        return None
    }
  },
  company: (role): AccessType => {
    switch (role) {
      case SystemAdministrator:
        return All
      case CompanyAdministrator:
        return Read | Update
      case Facilitator:
        return Read | Update
      case Operator:
      case External:
        return Read
      default:
        return None
    }
  },
  location: (role): AccessType => {
    switch (role) {
      case SystemAdministrator:
      case CompanyAdministrator:
        return All
      case Facilitator:
        return Read | Update
      case Operator:
      case External:
        return Read
      default:
        return None
    }
  },
  building: (role): AccessType => {
    switch (role) {
      case SystemAdministrator:
      case CompanyAdministrator:
        return All
      case Facilitator:
        return Read | Update
      case Operator:
      case External:
        return Read
      default:
        return None
    }
  },
  floor: (role): AccessType => {
    switch (role) {
      case SystemAdministrator:
      case CompanyAdministrator:
      case Facilitator:
        return All
      default:
        return None
    }
  },
  user: (role): AccessType => {
    switch (role) {
      case SystemAdministrator:
      case CompanyAdministrator:
      case Facilitator:
        return All
      default:
        return None
    }
  },
  workspaceDetail: (role): AccessType => {
    switch (role) {
      case SystemAdministrator:
      case CompanyAdministrator:
      case Facilitator:
      case Operator:
        return Read
      default:
        return None
    }
  },
  schedule: (role): AccessType => {
    switch (role) {
      case SystemAdministrator:
      case CompanyAdministrator:
      case Facilitator:
      case Operator:
        return Read
      default:
        return None
    }
  },
  zone: (role): AccessType => {
    switch (role) {
      case SystemAdministrator:
      case CompanyAdministrator:
      case Facilitator:
      case Operator:
        return Read
      default:
        return None
    }
  },
  settings: (role): AccessType => {
    switch (role) {
      case SystemAdministrator:
        return All
      default:
        return None
    }
  },
} satisfies Record<string, (role?: RoleType) => AccessType>
/* eslint-enable  prettier/prettier */

export type PermissionContext = keyof typeof RolePermissions

export interface Data {
  id: number
  name: string
  description?: string
}

class Role extends Model<Data> {
  get name() {
    return this.data.name
  }
}

export default Role
